<template>
	<div class="about-box" :style="{'background-image': `url(${Recruitment.bgImg})`}">
		<van-image class="title" :src="Recruitment.titleImg"/>
		<!-- <van-icon class="arrow topArrow" name="arrow-up" color="#ffffff" @click="scroll(-1)" /> -->
		<div class="zhiwei-box">
			<div class="zhiwei" v-for="(item, index) in items" :key="index" :class="{'active': index === currentIndex}"
				@click="showSecond(index)">
				{{item}}
			</div>
		</div>
		<!-- <van-icon class="arrow bottomArrow" name="arrow-down" color="#ffffff" @click="scroll(1)" /> -->
		<van-popup class="detail-box" :overlay="false" :get-container="getContainer" v-model="showDetail">
			<div class="sub-content" v-if="tabIndex==0">
				<van-row class="row-style">
				  <van-col class="title-sub">大客户经理</van-col>
				  <!-- <van-col class="email-icon" @click="showEmailContent()"><span class="" ></span></van-col> -->
				</van-row>
				<div class="detail-con">
					<p>工作地点：广州、武汉、云南</p>
					<p>所属部门：市场销售部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责当地市场的开发和上量工作；</li>
						<li>2. 根据公司整体市场发展策略，专业推广现有产品线；</li>
						<li>3. 高效完成相关全国及地区性各项学术活动；</li>
						<li>4. 确保公司所制定的各项责任区域销售指标的100%达成；</li>
						<li>5. 维护和发展现有正在合作的客户，配合公司整体资源与相关代理商共同发展更多的目标客户；</li>
						<li>6. 科学管理责任区域内现有经销商，针对尚未开发目标市场有计划性的发展有价值的新经销商。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<li>1. 本科学历，男女不限；</li>
					<li>2. 至少5年医疗器械领域或外企医药领域工作经验；</li>
					<li>3. 医学相关专业优先考虑，心血管领域工作经验优先考虑；</li>
					<li>4. 销售能力突出、执行力强；</li>
					<li>5. 沟通能力和团队协作能力好。</li><br/><br/>
					简历请发邮箱：<br/>
					luojing@kingstronbio.com<br/><br/>
					
					联系人：罗经理<br/><br/>
					
					电话：010-84148525 转 2018<br/><br/>
					
					信件接收地址:<br/>
					北京朝阳区望京科技创业园F座3层302室<br/><br/>
					
					邮编：100102
				</div>
			</div>
			<div class="sub-content" v-if="tabIndex==1">
				<van-row class="row-style">
				  <van-col class="title-sub">高级研发工程师</van-col>
				  <!-- <van-col class="email-icon" @click="showEmailContent()"><span class="" ></span></van-col> -->
				</van-row>
				<div class="detail-con">
					<p>工作地点：北京望京</p>
					<p>所属部门：研发部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责科技项目申请；</li>
						<li>2. 协助产品研发工作；</li>
						<li>3. 与相关部门进行工作协调，进行新产品研发、技术创新、工艺技术改进工作，有项目管理经验者优先；</li>
						<li>4. 熟悉医疗器械产品的各项法规要求、ISO13485。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<ol>
						<li>1. 具有理工科（化学、材料、机械学）或医学相关的博士或硕士学位，有高影响因子英文论文3篇以上优先；</li>
						<li>2. 具有国级或者省部级科技项目申请经历，有优秀的项目申请书撰写经验者优先；</li>
						<li>3. 具有严谨的科研态度，较强的论文撰写能力；</li>
						<li>4. 有良好的人际交流及沟通能力，优秀的团队合作能力和实验动手能力；</li>
						<li>5. 化学、材料、机械等专业优先，工作经验不限。</li>
					</ol>
					<br/>
					简历请发邮箱：<br/>
					luojing@kingstronbio.com<br/><br/>
					
					联系人：罗经理<br/><br/>
					
					电话：010-84148525 转 2018<br/><br/>
					
					信件接收地址:<br/>
					北京朝阳区望京科技创业园F座3层302室<br/><br/>
					
					邮编：100102
				</div>
			</div>
			<div class="sub-content" v-if="tabIndex==2">
				<van-row class="row-style">
				  <van-col class="title-sub">研发工程师</van-col>
				  <!-- <van-col class="email-icon" @click="showEmailContent()"><span class="" ></span></van-col> -->
				</van-row>
				<div class="detail-con">
					<p>工作地点：北京望京</p>
					<p>所属部门：研发部</p>
					<p><strong>岗位职责：</strong></p>
					<ol>
						<li>1. 负责产品相关设计、产品生产工艺开发及生产设备选型；</li>
						<li>2. 参与或组织产品研发相关活动（策划、立项、输入、产品设计、产品验证/确认、输出、设计更改、风险管理）各类评审活动及相关会议；</li>
						<li>3. 负责分管产品和零部件结构设计开发和图纸化；</li>
						<li>4. 负责产品及生产工艺的验证或确认、负责建立产品检测方法及设备选型；</li>
						<li>5. 负责或协助新产品的工艺导入、工艺确认、生产设备和工装的开发；与生产部门、制造商协调确保产品满足生产工艺要求；</li>
						<li>6. 负责设计变更同步的设计图纸、文件的修改和验证；</li>
						<li>7. 负责与质量部门沟通协调，确保设计及输出文件满足公司质量体系和相关法规要求；</li>
						<li>8. 协助进行新产品涉及的生产工艺和使用的培训；</li>
						<li>9. 负责产品设计开发涉及的专利的撰写申报。</li>
					</ol>
					<p><strong>任职要求：</strong></p>
					<ol>
						<li>1. 本科及以上学历，机械、材料、高分子相关专业；</li>
						<li>2. 具有5年以上工作经验，具有医疗器械，尤其是植入医疗器械研发经验者优先考虑；</li>
						<li>3. 有塑料模具件相关医疗产品设计和开发经验者优先考虑；</li>
						<li>4. 熟练使用常用制图软件；</li>
						<li>5. 熟悉医疗器械的法律法规、ISO 13485质量体系或YY/T0287，熟悉YY/T 0316风险管理；</li>
						<li>6. 熟练使用办公软件；</li>
						<li>7. 工作勤奋踏实，思维清晰；创新意识强，具有良好的沟通能力与协作精神。</li>
					</ol>
					<br/>
					简历请发邮箱：<br/>
					luojing@kingstronbio.com<br/><br/>
					
					联系人：罗经理<br/><br/>
					
					电话：010-84148525 转 2018<br/><br/>
					
					信件接收地址:<br/>
					北京朝阳区望京科技创业园F座3层302室<br/><br/>
					
					邮编：100102
				</div>
			</div>
			
		</van-popup>
		<!-- <van-popup class="detail-box detail-box2" :overlay="false" :get-container="getContainer" v-model="showEmail">
			<div class="sub-content">
				简历请发邮箱：<br/>
				luojing@kingstronbio.com<br/><br/>

				联系人：<br/>
				罗经理<br/><br/>

				电话：<br/>
				010-84148525 转 2018<br/><br/>

				信件接收地址:<br/>
				北京朝阳区望京科技创业园F座3层302室<br/><br/>

				邮编：<br/>
				100102
			</div>
		</van-popup> -->
	</div>
</template>

<script>
	import { eventBus } from '@/main.js'
	export default {
		name: 'Recruitment',
		props:{
			subActiveIndex:{
				type:Number,
				default: 0
			}
		},
		data() {
			return {
				Recruitment: {
					titleImg: require("../../../static/m/recruitment/title-recruitment.png"),
					bgImg: require("../../../static/m/recruitment/bg-recruitment.png"),
					zhiwei: ['大客户经理','高级研发工程师','研发工程师'],
					moreImg: require("../../../static/m/common/more2-dark.png")
				},
				currentIndex: 0,
				itemsPerPage: 4,
				showDetail: false,
				tabIndex: 0,
				showEmail: false,
				detailType: 1,//1 :一级页面   2.二级页面  email 弹窗
			}
		},
		computed: {
			items() {
				return this.Recruitment.zhiwei.slice(this.currentIndex, this.currentIndex + this.itemsPerPage)
			}
		},
		methods: {
			scroll(direction) {
				const newIndex = this.currentIndex + direction * this.itemsPerPage
				if (newIndex < 0 || newIndex >= this.Recruitment.zhiwei.length) {
					return
				}
				this.currentIndex = newIndex
			},
			showSecond(index) {
				this.tabIndex = index;
				this.showDetail = true;
				this.detailType = 1,
				this.$store.commit("setBgColor", '#e5e3e1');
				this.$store.commit("setSecondPage", true);
			},
			showEmailContent(){
				this.showEmail = true;
				this.detailType = 2,
				this.$store.commit("setSecondPage", true);
			},
			getContainer() {
				return document.querySelector('.m-pageSwiper');
			},
			onClickCloseIcon(){
				this.showDetail = false;
				this.showEmail = false;
				this.$store.commit("setSecondPage", false);
			}
		},
		mounted() {
			var that = this;
			if (this.subActiveIndex) {
				this.$refs.proSwipe.swipeTo(this.subActiveIndex)
			}
			//监听事件
			eventBus.$on('closeSecondPage', (index) => {
				// this.showDetail = false;
				if(index == 6){
					if(that.detailType == 2) {
						that.showEmail = false;
						that.showDetail = true;
						that.detailType = 1;
						this.$store.commit("setSecondPage", true);
					}else{
						that.showDetail = false;
						this.$store.commit("setSecondPage", false);
						// that.showPageList = false;
					}
				}
			});
		}
	}
</script>

<style lang="less" scoped>
@import url('@/assets/css/index.less');
	.about-box {
		background-color: #fff;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-position: bottom center;
		background-size: 1125/@r 2436/@r;
	}
	.arrow {
		.scale(60,60);
		font-size: 60/@r;
		position: absolute;
		left:50%;top:50%;
		z-index: 99;
		transform: translate(-50%,-50%);
	}
	.topArrow {
		margin-top: -340/@r;
	}
	.bottomArrow {
		margin-top: 340/@r;
	}
	.zhiwei-box {
		position: absolute;
		left:50%;top:50%;
		z-index: 99;
		transform: translate(-50%,-50%);
		.scale(825,587);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.zhiwei {
			color: #ffffff;
			font-size: 50/@r;
			font-weight: bold;
			line-height: 108/@r;
			text-align: center;
			background-image: url('../../../static/m/recruitment/item-box.png');
			background-repeat: no-repeat;
			background-size: 825/@r 108/@r;
			.scale(825,108);
		}
	}
	.title {
		.scale(314,173);
		.pos-a(170,150,99);
	}
	.more {
		.scale(825,108);
		position: absolute;
		bottom: 330/@r;
		z-index: 99;
		left: 50%;
		transform: translateX(-50%);
	}
	.detail-box {
		background-color: #e5e3e1;
		width:100%;
		height:100%;
		display: block;
		/deep/.van-popup__close-icon {
			font-size: 30px;
			color:#4d4d4d;
		}
		.sub-content {
			padding: 0 105/@r 200/@r;
			.row-style{
				margin-top: 196/@r;
			}
			.title-sub{
				color: #4d4d4d;
				font-size: 80/@r;
				// margin-top: 196/@r;
			}
			.email-icon{
				.scale(74,74);
				margin-left: 70/@r;
				display: inline-block;
				background-image: url('../../../static/m/recruitment/icon.png');
				background-size: 74/@r 74/@r;
				margin-top: 15/@r;
			}
			.detail-con{
				margin-top: 80/@r;
				font-size: 40/@r;
				margin-bottom: 30/@r;
			}
		}
	}
	.detail-box2{
		// background-color: #000;
		// color: #fff;
		.sub-content{
			font-size: 45/@r;
			margin-top: 356/@r;
			margin-left: 112/@r;
			padding: 0 !important;
		}
		/deep/.van-icon{
			color: #fff;
		}
	}
</style>